"use client";
import Button from "@/Components/Common/Buttons/Buttons";
import { useForm, Controller } from "react-hook-form";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import "react-day-picker/style.css";
import { calendarDateFormat, convertDateTimeToUTC, convertDateToUTC, convertTimeTo24HourWithDateFormat, dayJsDate, generateAppointmentTimeSlots } from "@/utils/common";
import useAppointments from "@/reactQuery/appointment";
import useAvailability from "@/reactQuery/availability";
import { useCreateAppointmentMutation } from "@/Redux/apis/appointments";
import socketService from "../../../utils/socket";
import useHolidays from "@/reactQuery/holidays";
import {
  calendarDateFormatInString, convertAndSplitSchedule,
  convertTimeSlotsToUserTimezone,
  convertTimeSlotsWithDayAdjustment,
  convertUTCToUserTimezone, getDayOfWeek
} from "../../../utils/common";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { sendMessageDB } from "@/services/message";
import { addMessage } from "@/Redux/slice/chatSlice";
import { store } from "@/Redux/store/store";

const CustomDateInput = ({ value, onClick }) => (
  <div
    onClick={onClick}
    className="w-[356px] self-stretch px-4 pt-2 mt-2 cursor-pointer pb-2.5 bg-neutral-50 rounded-lg border border-blue-600 justify-start items-center gap-4 inline-flex"
  >
    <div className="w-4 h-4 relative flex-col justify-start items-start flex">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipRule="url(#clip0_265_11073)">
          <path
            d="M12.9109 1.23215H12.3141V0.628262C12.3141 0.283228 12.0344 0.00354004 11.6894 0.00354004C11.3444 0.00354004 11.0647 0.283228 11.0647 0.628262V1.23215H4.9353V0.628262C4.9353 0.283228 4.65561 0.00354004 4.31058 0.00354004C3.96555 0.00354004 3.68586 0.283228 3.68586 0.628262V1.23215H3.08909C1.38576 1.23215 0 2.61791 0 4.32121V12.9073C0 14.6107 1.38576 15.9964 3.08909 15.9964H12.9109C14.6142 15.9964 16 14.6107 16 12.9073V4.32121C16 2.61791 14.6142 1.23215 12.9109 1.23215ZM3.08909 2.48159H3.68586V3.6998C3.68586 4.04483 3.96555 4.32452 4.31058 4.32452C4.65561 4.32452 4.9353 4.04483 4.9353 3.6998V2.48159H11.0647V3.6998C11.0647 4.04483 11.3444 4.32452 11.6894 4.32452C12.0345 4.32452 12.3141 4.04483 12.3141 3.6998V2.48159H12.9109C13.9253 2.48159 14.7506 3.30685 14.7506 4.32121V4.91801H1.24944V4.32121C1.24944 3.30685 2.0747 2.48159 3.08909 2.48159ZM12.9109 14.747H3.08909C2.0747 14.747 1.24944 13.9217 1.24944 12.9073V6.16745H14.7506V12.9073C14.7506 13.9217 13.9253 14.747 12.9109 14.747ZM5.54962 8.6247C5.54962 8.96974 5.26993 9.24942 4.9249 9.24942H3.69629C3.35126 9.24942 3.07157 8.96974 3.07157 8.6247C3.07157 8.27967 3.35126 7.99998 3.69629 7.99998H4.9249C5.2699 7.99998 5.54962 8.27967 5.54962 8.6247ZM12.9285 8.6247C12.9285 8.96974 12.6488 9.24942 12.3037 9.24942H11.0751C10.7301 9.24942 10.4504 8.96974 10.4504 8.6247C10.4504 8.27967 10.7301 7.99998 11.0751 7.99998H12.3037C12.6487 7.99998 12.9285 8.27967 12.9285 8.6247ZM9.23548 8.6247C9.23548 8.96974 8.95579 9.24942 8.61076 9.24942H7.38215C7.03712 9.24942 6.75743 8.96974 6.75743 8.6247C6.75743 8.27967 7.03712 7.99998 7.38215 7.99998H8.61076C8.95576 7.99998 9.23548 8.27967 9.23548 8.6247ZM5.54962 12.3106C5.54962 12.6556 5.26993 12.9353 4.9249 12.9353H3.69629C3.35126 12.9353 3.07157 12.6556 3.07157 12.3106C3.07157 11.9655 3.35126 11.6858 3.69629 11.6858H4.9249C5.2699 11.6858 5.54962 11.9655 5.54962 12.3106ZM12.9285 12.3106C12.9285 12.6556 12.6488 12.9353 12.3037 12.9353H11.0751C10.7301 12.9353 10.4504 12.6556 10.4504 12.3106C10.4504 11.9655 10.7301 11.6858 11.0751 11.6858H12.3037C12.6487 11.6858 12.9285 11.9655 12.9285 12.3106ZM9.23548 12.3106C9.23548 12.6556 8.95579 12.9353 8.61076 12.9353H7.38215C7.03712 12.9353 6.75743 12.6556 6.75743 12.3106C6.75743 11.9655 7.03712 11.6858 7.38215 11.6858H8.61076C8.95576 11.6858 9.23548 11.9655 9.23548 12.3106Z"
            fill="#354EF0"
          />
        </g>
        <defs>
          <clipPath id="clip0_265_11073">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div className="text-black text-xs font-medium font-poppins">{value}</div>
  </div>
);
const RescheduleAppointments = ({ appointment, onClose, repData, closeOnSubmit, setCalendarKey = null }) => {
  console.log(repData, "REPDATA")
  const defaultClassNames = getDefaultClassNames();
  const [load, setLoad] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availabilityData, setAvailabilityData] = useState({});
  const [availableSlots, setAvailableSlots] = useState();
  const [selectedSlot, setSelectedSlot] = useState(null);
  const users = useSelector((state) => state?.userData?.userData?.user);
  const { rescheduleAppointmentMutation } = useAppointments({ userId: users._id, currentDate: dayJsDate() })
  const [holidaysList, setHolidaysList] = useState([]);
  const { holidays } = useHolidays({ userId: repData?._id });
  const { availability, saveAvailabilityMutation } = useAvailability({ userId: repData?._id });
  const dispatch = useDispatch();
  const [createAppointmentApi, createAppointmentResponse] = useCreateAppointmentMutation();
  useEffect(() => {
    if (holidays.length > 0) {
      const holidayArray = holidays.map((holiday) => {
        return new Date(holiday.date)
      })
      setHolidaysList(holidayArray)
    }
  }, [holidays])
  useEffect(() => {
    if (!availability.isLoading) {
      const availabilityDataFromDb = availability?.data?.availability;
      if (availabilityDataFromDb && availabilityDataFromDb?.schedule) {
        let convertedSchedule = {};
        convertedSchedule = convertAndSplitSchedule(availabilityDataFromDb?.schedule, availabilityDataFromDb?.userId?.timezone, users?.timezone, availabilityDataFromDb?.duration);
        availabilityDataFromDb.schedule = convertedSchedule;
      }
      setAvailabilityData(availabilityDataFromDb ? availabilityDataFromDb : []);
    } else if (availability?.isError) {
      setAvailabilityData([]);
    }
  }, [
    selectedDate,
    availability?.data,
    availability?.isLoading,
    availability?.isError,
  ]);


  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const dateValue = watch('date');

  useEffect(() => {
    if (dateValue) {
      const dayOfWeek = getDayOfWeek(dateValue);

      if (dayOfWeek === null || dayOfWeek === undefined) {
        setAvailableSlots(null);
        return;
      }

      const nowInToZone = dayjs().tz(users?.timezone);

      // Check if the selected date is today
      const isToday = dayjs(dateValue).isSame(nowInToZone, 'day');

      if (isToday) {
        setAvailableSlots(availabilityData?.schedule?.today);
      } else {
        const slotsForDay = availabilityData?.schedule?.otherDays[dayOfWeek] || [];
        setAvailableSlots(slotsForDay);
      }
    }
  }, [dateValue, availabilityData])

  useEffect(() => {
    if (appointment._id && availabilityData?.duration) {

      reset({
        reason: appointment.reason,
        date: calendarDateFormat(appointment.startTime)
      })

      setSelectedSlot({
        startTime: appointment.startTime,
        endTime: appointment.endTime,
      })

    }
  }, [appointment, availabilityData]);


  const onSubmit = async (data) => {
    // console.log('selectedSlot', selectedSlot)
    if (!selectedSlot) {
      toast.error("Please select a slot.",)
      return;
    }
    setLoad(true);
    const payload = {
      startTime: convertDateTimeToUTC(calendarDateFormat(data.date), selectedSlot.startTime),
      endTime: convertDateTimeToUTC(calendarDateFormat(data.date), selectedSlot.endTime),
      date: convertDateToUTC(calendarDateFormat(data.date)),
      type: 'client',
      reason: data.reason,
      id: appointment._id,
      userId: users._id
    }
    rescheduleAppointmentMutation.mutate(payload);
    if (closeOnSubmit) {
      closeOnSubmit();

    }
  };

  const handleDateChange = (date) => {
    if (!date) {
      return;
    }

    console.log(date, 'date || new Date()');
    setSelectedSlot(null);
    setSelectedDate(date);
    setValue("date", date);
  };

  useEffect(() => {
    handleRescheduleAppointmentMutation()
  }, [rescheduleAppointmentMutation]);

  const handleRescheduleAppointmentMutation = async () => {
    if (rescheduleAppointmentMutation?.isLoading) {
      setLoad(true);
    } else if (
      !rescheduleAppointmentMutation?.isLoading &&
      rescheduleAppointmentMutation?.isSuccess
    ) {
      console.log(rescheduleAppointmentMutation, "Reschedule")

      let message = rescheduleAppointmentMutation?.data?.slot;
      const msgResponse = await sendMessageDB({
        senderId: users?._id === message?.repId ? message?.repId : message?.doctorId,
        receiverId: users?._id === message?.repId ? message?.doctorId : message?.repId,
        profilePic: users?.profile,
        appointmentId: message?._id,
        reason: message?.reason,
        senderName: users?.firstName + " " + users.lastName,
        createdAt: new Date().toISOString(),
      })
store.dispatch(addMessage({ success: true, data: msgResponse?.data }))
      socketService.sendMessage(msgResponse);
      if (setCalendarKey) {
        setCalendarKey((preState) => preState + 1);
      }
      onClose()
      setLoad(false);
    } else if (
      rescheduleAppointmentMutation?.isError &&
      rescheduleAppointmentMutation?.status === "rejected"
    ) {
      setLoad(false);

    }
  }
  return (
    <>
      <div className="fixed inset-0 popup-bg z-50 flex justify-center items-end sm:items-center">
        <div className="w-full sm:w-[440px] bg-white rounded-none sm:rounded-2xl shadow-2xl border border-neutral-200 h-full sm:h-auto sm:max-h-[90vh] flex flex-col overflow-hidden">
          {/* Header */}
          <div className="px-4 sm:px-5 pt-4 sm:pt-5 pb-3 border-b border-neutral-200 flex-shrink-0">
            <div className="flex justify-between items-center">
              <div className="text-black text-base sm:text-lg font-semibold font-poppins">
                Book Appointment
              </div>
              <div
                onClick={onClose}
                className="cursor-pointer hover:bg-gray-100 rounded-full p-1 transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect width="24" height="24" fill="white" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.00073 17.5864C4.61023 17.977 4.61029 18.6101 5.00085 19.0006C5.39141 19.3911 6.02457 19.3911 6.41506 19.0005L12.0003 13.4143L17.586 19C17.9765 19.3905 18.6097 19.3905 19.0002 19C19.3907 18.6095 19.3907 17.9763 19.0002 17.5858L13.4144 12L18.9998 6.41359C19.3902 6.02303 19.3902 5.38987 18.9996 4.99938C18.6091 4.60888 17.9759 4.60894 17.5854 4.9995L12.0001 10.5858L6.41438 4.99998C6.02386 4.60946 5.39069 4.60946 5.00017 4.99998C4.60964 5.39051 4.60964 6.02367 5.00017 6.4142L10.5861 12.0001L5.00073 17.5864Z"
                    fill="#8E8E8E"
                  />
                </svg>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="flex-1 flex flex-col overflow-hidden">
            {/* Scrollable Content */}
            <div className="px-4 sm:px-5 py-4 flex-1 overflow-y-auto">
              <div className="flex flex-col gap-4">
                {/* Reason */}
                <div className="flex flex-col gap-2">
                  <div className="text-neutral-400 text-xs font-medium font-poppins">
                    Appointment Reason
                  </div>
                  <div>
                    <textarea
                      {...register("reason", { required: "Reason is required" })}
                      className="w-full p-2.5 border border-blue-600 rounded-lg text-black text-sm font-poppins"
                      rows="2"
                      style={{ resize: "none" }}
                    />
                    {errors.reason && (
                      <p className="text-red-500 text-xs mt-1">{errors.reason.message}</p>
                    )}
                  </div>
                </div>

                {/* Date Picker */}
                <div className="flex flex-col gap-2">
                  <div className="text-neutral-400 text-xs font-medium font-poppins">
                    Appointment Date
                  </div>
                  <div className="text-black text-xs font-medium font-poppins w-full overflow-x-auto">
                    <Controller
                      control={control}
                      name="date"
                      rules={{ required: "Appointment Date is required" }}
                      render={({ field }) => {
                        const localDate = convertUTCToUserTimezone(field.value, users?.timezone);
                        return (
                          <DayPicker
                            mode="single"
                            selected={localDate}
                            onSelect={handleDateChange}
                            disabled={[...holidaysList, { before: new Date() }]}
                            classNames={{
                              today: `border-amber-500`,
                              selected: `${defaultClassNames.selected}`,
                              root: `${defaultClassNames.root} border-solid border-2 border-neutral-100 rounded-lg p-3 sm:p-5 w-full`,
                              chevron: `${defaultClassNames.chevron} fill-amber-500`,
                            }}
                          />
                        )
                      }}
                    />
                    {errors.date && (
                      <p className="text-red-500 text-xs mt-1">{errors.date.message}</p>
                    )}
                  </div>
                </div>

                {/* Time Slots */}
                {watch("date") && (
                  <div className="flex flex-col gap-2">
                    <div className="text-neutral-400 text-xs font-medium font-poppins">
                      Appointment Slot
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {(availableSlots && availableSlots?.length > 0) ? availableSlots?.map((slot, key) => (
                        <div key={key}
                          onClick={() => setSelectedSlot(slot)}
                          className={`px-2 sm:px-3 py-2 cursor-pointer rounded-lg border justify-center items-center gap-1 flex
                            ${convertTimeTo24HourWithDateFormat(selectedSlot?.startTime)
                              ==
                              convertTimeTo24HourWithDateFormat(slot.startTime) &&
                              convertTimeTo24HourWithDateFormat(selectedSlot?.endTime)
                              == convertTimeTo24HourWithDateFormat(slot.endTime) ?
                              "bg-[#2e45df] text-[#fff] border-[#2e45df]" : "bg-neutral-100 border-blue-600 text-neutral-600"
                            }`}>
                          <div className="text-[11px] sm:text-[12px] font-medium font-poppins whitespace-nowrap">
                            {convertTimeTo24HourWithDateFormat((slot?.startTime))} - {convertTimeTo24HourWithDateFormat(slot?.endTime)}
                          </div>
                        </div>
                      )) : <p className="text-black text-sm">Slot not available!</p>}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Fixed Bottom Buttons */}
            <div className="px-4 sm:px-5 py-3 sm:py-4 border-t border-gray-200 flex gap-2 sm:gap-3 flex-shrink-0 mt-auto bg-white">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={!selectedSlot || rescheduleAppointmentMutation.isPending}
                className={`flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${
                  !selectedSlot || rescheduleAppointmentMutation.isPending
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#2e45df] hover:bg-[#2539c0] shadow-md hover:shadow-lg"
                }`}
              >
                {rescheduleAppointmentMutation.isPending ? 'Loading...' : 'Reschedule'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RescheduleAppointments;
